import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { getAllCourseComplete,fetchDropdownDataAPI } from '../services/userApi';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './MyCalendar.css'; // นำเข้า CSS ที่สร้างขึ้น
import backgroundImage from '../assets/Frame_67.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCalendar, faClock, } from '@fortawesome/free-regular-svg-icons';
import { faMagnifyingGlass,faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/th'; 

dayjs.locale('th'); 

const MyCoursePage = () => {
    const navigate = useNavigate();
    const MySwal = withReactContent(Swal);

    const [loading, setLoading] = useState(true); // สถานะการโหลดข้อมูล    
    const [changeMonth, setChangeMonth] = useState(new Date());
    const [date, setDate] = useState(new Date());
    const [filterCourseData, setFilterCourseData] = useState([]);
    const [courseData, setCourseData] = useState([]);
    const [user, setUser] = useState(null);

     // course metadata
     const metadata = JSON.parse(localStorage.getItem('courseData'));
     const courseNameCreateData = [ ...metadata.course_names ];    
     const categoryCreateData = [ ...metadata.categorys ];
     const subjectCreateData = [ ...metadata.subjects ];
     const yearCreateData = [ ...metadata.years ];
     const generationCreateData = [ ...metadata.generations ]; 
     
     //responsive
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 1025);

     //dropdown
     const [roomsDropdownData, setRoomsDropdownData] = useState([]);
     const [categoriesDropdownData, setCategoriesDropdownData] = useState([]);
     const [YearDropdownData, setYearDropdownData] = useState([]);
     const [GenDropdownData, setGenDropdownData] = useState([]);
     //เลือกใน dropdown
     const [selectedRoom, setSelectedRoom] = useState(''); //อันนี้ใช้เป็นของcourse_name
     const [selectedCategory, setSelectedCategory] = useState('');
     const [selectedSubject, setSelectedSubject] = useState('');
     const [selectedGen, setSelectedGen] = useState('');
     const [selectedYear, setSelectedYear] = useState('');
     const [selectedDate, setSelectedDate] = useState('');
     const [selectedTime, setSelectedTime] = useState('');
     //detail dropdown
     const [showRoomDropdown, setShowRoomDropdown] = useState(false);
     const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
     const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
     const [showYearDropdown, setShowYearDropdown] = useState(false);
     const [showGenDropdown, setShowGenDropdown] = useState(false);
     const [filteredSubjects, setFilteredSubjects] = useState([]);
     const [filteredCategories, setFilteredCategories] = useState([]);

      //filter dropdown
    const [subjectsDropdownData, setSubjectsDropdownData] = useState([]);


    //page
    const [currentPage, setCurrentPage] = useState(1); // จัดการหมายเลขหน้า
    const [pageSize] = useState(3); // ขนาดของข้อมูลต่อหน้า
    const [totalPages, setTotalPages] = useState(10); // จัดการจำนวนหน้าทั้งหมด
 
    
    const handleResize = () => {
        setIsSmallScreen(window.innerWidth < 1025);
    };

    useEffect(() => {
        fetchDropdownData();
        fetchUserData();
        loadAllCourses();
        // ติดตั้ง event listener สำหรับการเปลี่ยนขนาดหน้าจอ
        window.addEventListener('resize', handleResize);

        // ฟังก์ชันคืนค่า
        return () => {
            document.body.style.overflow = 'auto'; // คืนค่าการเลื่อนเมื่อคอมโพเนนต์ถูกถอดออก
            window.removeEventListener('resize', handleResize); // ลบ event listener
        };
    }, [changeMonth,currentPage, pageSize]);

    const onError = (title,response) => {
        MySwal.fire({
            title: title,
            html: response?.data?.error?.message,
            icon: "error",
            confirmButtonText: "Close",
            allowOutsideClick: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
              if(response?.status===401) {
                  sessionStorage.removeItem('hasVisited');
                  sessionStorage.removeItem('lastPath');        
                  localStorage.removeItem('account');                  
                  navigate('/');
              };
          }
        });
    };
    const fetchUserData = async () => {
        try {
            const userData = JSON.parse(localStorage.getItem('account'));
            if (userData) {
                setUser(userData);
            }
        } catch (error) {
            console.error('Failed to fetch user data:', error);
        }
    };

    const onInfo = (title, message) => {
        MySwal.fire({
            icon: 'info',
            title: title,
            text: message,
            confirmButtonText: 'Close',
            allowOutsideClick: false,
        });
    };    

    const convertTimeFormat = (timeStr) => {
        let [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':');

        if (hours === '12') {
            hours = '00';
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    };



    const handleMonthChange = ({ activeStartDate, view }) => {
        const dateString = activeStartDate.toLocaleDateString('en-CA');
        
        setFilterCourseData([]);
        setChangeMonth(dateString)
    }    

    const handleDayClick = (date) => {
        setDate(date);
        
        const dateString = date.toLocaleDateString('en-CA'); // ใช้รูปแบบ 'YYYY-MM-DD'
        const messages = courseData?.filter(item => item.date === dateString); 

        //setCourseData(messages);
        setFilterCourseData(messages);
    };

    const onChange = (newDate) => {
        setDate(newDate);
    };    
    const onSelectCourse = (courseUid) => {
        //navigate(`../course?id=${courseId}`);
        navigate('../course', { state: { courseUid: courseUid,activeTab: 'Detail'  } });
    };    

    // แสดงข้อมูลใน Calendar
    const tileContent = ({date}) => {
        if (loading) return null; // หากข้อมูลยังโหลดไม่เสร็จ ไม่แสดง tileContent
    
        const maxContent = 3;      
        const dateString = date.toLocaleDateString('en-CA'); // ใช้รูปแบบ 'YYYY-MM-DD'
        const messages = courseData?.filter(item => item.date === dateString); 
    
        if (messages.length > 0) {
            const displayMessages = messages.slice(0, maxContent); // แสดงเฉพาะ 5 ข้อความแรก
            const additionalCount = messages.length > maxContent ? messages.length - maxContent : 0; // จำนวนที่เหลือ
    
            return (
                <div style={{ color: 'blue', textAlign: 'left', marginTop: '5px', marginLeft: '2px', marginRight: '2px' }}> {/* ปรับข้อความชิดซ้าย */}
                    {displayMessages.map((message, index) => (
                            <div key={index} style={{
                            backgroundColor: index % 2 === 0 ? '#cce5ff' : '#ffffbb', // สลับสีแถบ #d4edda
                            color: '#000',
                            //padding: '5px',
                            whiteSpace: 'nowrap', // ป้องกันการปัดบรรทัด
                            borderRadius: '10px 0px',
                            marginTop: '2px', // ระยะห่างระหว่างแถบ
                            fontSize: '14px',
                        }}>
                            {getNameSubjectMetadata(message.subject)}
                        </div>
                    ))}
                            {additionalCount > 0 && ( // แสดง +x more ถ้ามีข้อความเพิ่มเติม
                                <div style={{
                                    //backgroundColor: '#d4edda',
                                    color: '#000',
                                    textAlign: 'center',
                                    fontSize: '14px',
                                    //padding: '5px',
                                    //borderRadius: '4px',
                                    //marginBottom: '5px',
                                }}>
                                    +{additionalCount} more
                                </div>
                            )}        
                </div>
            );
        }
        return null;
    };

    const loadAllCourses = async () => {
        setLoading(true);
    
        try {
            const response = await getAllCourseComplete(selectedRoom,selectedCategory, selectedSubject,selectedGen, selectedYear, selectedDate, selectedTime, currentPage, pageSize);
            if (response && response.status === true && response.data && Array.isArray(response.data.courses)) {
                setCourseData(response.data.courses); // อัพเดตผลลัพธ์
                setFilterCourseData(response.data.courses);
                setTotalPages(response.data.total_page); // อัพเดตจำนวนหน้า
    
                // เพิ่ม log เพื่อตรวจสอบจำนวนหน้า
                console.log('Total pages:', response.data.total_page);
            } else {
                throw new Error('Invalid data structure');
            }
        } catch (error) {
            console.error('Error fetching courses:', error);
            onError('Error', error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
        } finally {
            setLoading(false);
        }
    };
    
    const handleShowAll = async () => {
        setLoading(true);
    
        // เคลียร์ค่าทุกช่องกรอก
        setSelectedYear('');
        setSelectedGen('');
        setSelectedSubject('');
        setSelectedRoom('');
        setSelectedCategory('');
        setSelectedDate('');
        setSelectedTime('');
    
        try {
            // เรียกฟังก์ชัน loadAllCourses โดยไม่ส่งพารามิเตอร์ที่กรอกไป (สามารถใช้ค่าว่างได้)
            const response = await getAllCourseComplete(
                null,  // ส่ง null แทนค่าว่าง
                null,  // ส่ง null แทนค่าว่าง
                null,  // ส่ง null แทนค่าว่าง
                null,  // ส่ง null แทนค่าว่าง
                null,  // ส่ง null แทนค่าว่าง
                null,  // ส่ง null แทนค่าว่าง
                null,  // ส่ง null แทนค่าว่าง
                currentPage,  // ส่งค่า currentPage และ pageSize ตามปกติ
                pageSize
            );
    
            if (response && response.status === true && response.data && Array.isArray(response.data.courses)) {
                setCourseData(response.data.courses);  // อัปเดตข้อมูลที่ดึงมา
                setFilterCourseData(response.data.courses);
                setTotalPages(response.data.total_page);  // อัปเดตจำนวนหน้า
            } else {
                throw new Error('Invalid data structure');
            }
        } catch (error) {
            console.error('Error fetching courses:', error);
            onError('Error', { data: { error: { message: 'เกิดข้อผิดพลาดในการดึงข้อมูล' } } });
        } finally {
            setLoading(false);
        }
    };
    

    const handleSearch = async () => {
        setLoading(true);
    
        // ตรวจสอบว่าฟิลด์ทั้งหมดว่างหรือไม่
        const isAllFieldsEmpty = !selectedYear && !selectedSubject && !selectedRoom && !selectedCategory && !selectedDate && !selectedTime && !selectedGen ;
    
        // ถ้าทุกฟิลด์ว่างให้แสดงข้อความเตือนและออกจากฟังก์ชัน
        if (isAllFieldsEmpty) {
            setLoading(false);
            return onError('Warning', { data: { error: { message: 'กรุณากรอกข้อมูลอย่างน้อย 1 ฟิลด์สำหรับการค้นหา' }}});
        }
    
        try {
            let response;
    
            // Log the search parameters for debugging
            console.log("Search Parameters:", {
                selectedGen,selectedYear, selectedSubject, selectedRoom, selectedCategory, selectedDate, selectedTime
            });
    
            // ถ้ามีค่าฟิลด์ที่เลือกให้ทำการค้นหา
            response = await getAllCourseComplete(selectedRoom, selectedSubject, selectedCategory,selectedGen, selectedYear, selectedDate, selectedTime, currentPage, pageSize);
    
            // Log the response for debugging
            console.log("API Response:", response);
    
            if (response && response.status === true && response.data && Array.isArray(response.data.courses)) {
                if (response.data.courses.length === 0) {
                    onInfo('ไม่พบรายวิชาเรียน', 'กรุณาค้นหาให้ถูกต้องตามรายวิชาเรียน');
                }
                setCourseData(response.data.courses);
                setFilterCourseData(response.data.courses);
                setTotalPages(response.data.total_page); // กำหนดจำนวนหน้าจาก response
            } else {
                throw new Error('Invalid data structure');
            }
        } catch (error) {
            // Log the error for debugging
            console.error("Search Error:", error);
            onError('Error', error?.response || { data: { error: { message: 'An unexpected error occurred' } } });
        } finally {
            setLoading(false);
        }
    };
    
        const handleSubmit = (event) => {
        event.preventDefault(); // ป้องกันการรีเฟรชหน้า
        handleSearch(); // เรียกฟังก์ชันค้นหา
    };

    const toggleDropdown = (dropdownType) => {
        if (dropdownType === 'RoomDropdown') {
            setShowRoomDropdown(prevState => !prevState);
            setShowCategoryDropdown(false);
            setShowSubjectDropdown(false);
            setShowYearDropdown(false);
            setShowGenDropdown(false);
        } else if (dropdownType === 'CategoryDropdown') {
            setShowCategoryDropdown(prevState => !prevState);
            setShowRoomDropdown(false);
            setShowSubjectDropdown(false);
            setShowYearDropdown(false);
            setShowGenDropdown(false);
        }
        else if (dropdownType==='SubjectDropdown'){
            setShowSubjectDropdown(prevState => !prevState);
            setShowCategoryDropdown(false);
            setShowRoomDropdown(false);
            setShowYearDropdown(false);
            setShowGenDropdown(false);
        }
        else if (dropdownType==='GenDropdown'){
            setShowGenDropdown(prevState => !prevState);
            setShowCategoryDropdown(false);
            setShowRoomDropdown(false);
            setShowSubjectDropdown(false);
            setShowYearDropdown(false);
        }
    };
   
    const fetchDropdownData = async () => {
        try {
            const response = await fetchDropdownDataAPI();
            const roomsData = Array.isArray(response.course_names) ? response.course_names : [];
            const categoriesData = Array.isArray(response.categorys) ? response.categorys : [];
            const subjectsData = Array.isArray(response.subjects) ? response.subjects : [];
            const YearsData = Array.isArray(response.years) ? response.years : [];
            const GensData = Array.isArray(response.generations) ? response.generations : [];
            
            setRoomsDropdownData(roomsData);
            setCategoriesDropdownData(categoriesData);
            setSubjectsDropdownData(subjectsData);
            setYearDropdownData(YearsData);
            setGenDropdownData(GensData);

            console.log({response})
        } catch (error) {
            console.error('Failed to fetch dropdown data:', error);
        }
    };
    
    const handleRoomClick = (room) => {
        // ตั้งค่า selectedRoom ให้เป็น 0 เมื่อ room เป็น null
        setSelectedRoom(room ? room.id : 0);
        setShowRoomDropdown(false);
        setFilteredCategories([]); 
        setSelectedCategory('');
        setFilteredSubjects([]);
        setSelectedSubject('');
    
        // กรอง categories ตาม room ที่เลือก
        const filteredCategories = room 
            ? categoriesDropdownData.filter(category => category.course_name_id === room.id) 
            : [];
    
        setFilteredCategories(filteredCategories);
        
        // ถ้า room เป็น null ไม่แสดง dropdown ของ category
        setShowCategoryDropdown(false);
    };
    
    const handleCategoryClick = (category) => {
        setSelectedCategory(category ? category.id : 0);
        setShowCategoryDropdown(false);
        setFilteredSubjects([]);
        setSelectedSubject('');
        
        // กรองหัวข้อที่ตรงกับ ID ของหมวดหมู่ที่เลือก
        const filteredSubjects = category 
            ? subjectsDropdownData.filter(subject => subject.category_id === category.id) 
            : [];
    
        setFilteredSubjects(filteredSubjects);
        setShowSubjectDropdown(false); // ปิด dropdown ของ subject
    };
    
    const handleSubjectClick = (subject) => {
        setSelectedSubject(subject ? subject.id : 0); // ตั้งค่าให้เป็นค่าว่างถ้าเลือก null
        setShowSubjectDropdown(false); // ปิด dropdown ของ subject
    };



    const handleYearClick = (year) => {
        setSelectedYear(year ? year.id : 0);
        setShowYearDropdown(false);
    };

    const handleGenClick = (generation) => {
        setSelectedGen(generation ? generation.id : 0);
        setShowGenDropdown(false);
    };

    const handleSeeMore = (courseUid) => {
        navigate('../course', { state: { courseUid: courseUid,activeTab: 'documents' } });
    };

    const getPaginationItems = () => {
        try {
            const pages = [];
            const maxPagesToShow = 5;
            const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);
        
            let startPage = Math.max(1, currentPage - halfMaxPagesToShow);
            let endPage = Math.min(totalPages, currentPage + halfMaxPagesToShow);
        
            if (currentPage - halfMaxPagesToShow <= 0) {
            endPage = Math.min(totalPages, endPage + (halfMaxPagesToShow - currentPage + 1));
            }
        
            if (currentPage + halfMaxPagesToShow >= totalPages) {
            startPage = Math.max(1, startPage - (halfMaxPagesToShow - (totalPages - currentPage)));
            }
        
            for (let page = startPage; page <= endPage; page++) {
            pages.push(page);
            }
        
            return pages;
        } catch (error) {            
            console.log("getPaginationItems catch: ", error);
        }        
    };
    const onPageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page); // เปลี่ยนหน้าปัจจุบัน
            console.log("Switched to page:", page);
            loadAllCourses(); // เรียก API ใหม่เมื่อเปลี่ยนหน้า
        }
    };

    const getNameCourseNameMetadata = (id) => { return courseNameCreateData.find(item => item.id === id).name || ''; };
    const getNameCagegoryMetadata = (id) => { return categoryCreateData.find(item => item.id === id).name || ''; };
    const getNameSubjectMetadata = (id) => { return subjectCreateData.find(item => item.id === id).name || ''; };
    const getNameGenerationMetadata = (id) => { return generationCreateData.find(item => item.id === id).name || ''; };    
    const getNameYearMetadata = (id) => { return yearCreateData.find(item => item.id === id).name || ''; };  
    

    const convertToThaiDate = (dateString) => {
        const months = [
            'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
            'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
        ];
        
        const date = new Date(dateString); // แปลงเป็น Date object
        const day = date.getDate(); // วัน
        const month = months[date.getMonth()]; // เดือน
        const year = date.getFullYear() + 543; // ปี พ.ศ.
    
        // คืนค่าเป็นรูปแบบ วัน เดือน ปี พ.ศ.
        return `${day} ${month} ${year}`;
    };
      

    return (
        <div>
            <div style={styles.background}></div>
            <div id="content" style={{ paddingTop: '75px',width:'100%',boxSizing:'border-box' }}>
            <div style={{padding:'20px'}}>
                    <div style={styles.searchcontent}>
                        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', width: '100%' }}>
                                {/* Section for Room and Category */}
                                <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                    <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
                                        {/* course */}
                                        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '50%' }}>
                                            <label htmlFor="name" style={{ marginBottom: '5px', fontSize: '18px', textAlign: 'left' }}>หลักสูตร</label>
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    value={selectedRoom ? getNameCourseNameMetadata(selectedRoom) : ''} 
                                                    readOnly
                                                    style={styles.inputShowtext}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faChevronDown}
                                                    style={styles.iconDropdown}
                                                    onClick={() => toggleDropdown('RoomDropdown')}
                                                />
                                            </div>
                                            {showRoomDropdown && (
                                                <div
                                                    id="RoomDropdown"
                                                    style={styles.dropdowncontent}
                                                >
                                                     <div
                                                       onClick={() => handleRoomClick(null)}
                                                        style={{
                                                            padding: '5px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #ddd',
                                                            height: '40px', // กำหนดความสูงให้เท่ากับตัวเลือกอื่น
                                                            lineHeight: '40px', // ปรับการจัดแนวให้ตรงกลาง
                                                        }}
                                                    >
                                                        &nbsp; {/* ใช้เพื่อให้ div ไม่ว่างเปล่า */}
                                                    </div>
                                                    {roomsDropdownData.map(room => (
                                                        <div
                                                            key={room.id}
                                                            onClick={() => handleRoomClick(room)}
                                                            style={styles.textDropdown}
                                                        >
                                                            {room.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>

                                        {/* หมวดหมู่ */}
                                        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '50%' }}>
                                            <label htmlFor="category" style={{ marginBottom: '5px', fontSize: '18px', textAlign: 'left' }}>หมวดวิชา</label>
                                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                                <input
                                                    type="text"
                                                    id="category"
                                                    name="category"
                                                    value={selectedCategory ? getNameCagegoryMetadata(selectedCategory) : ''}                                   
                                                    readOnly
                                                    style={styles.inputShowtext}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faChevronDown}
                                                    style={styles.iconDropdown}
                                                    onClick={() => toggleDropdown('CategoryDropdown')}
                                                />
                                            </div>
                                            {showCategoryDropdown && (
                                                
                                                <div
                                                    id="CategoryDropdown"
                                                    style={styles.dropdowncontent}
                                                >
                                                    <div
                                                        onClick={() => handleCategoryClick(null)}
                                                        style={{
                                                            padding: '5px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #ddd',
                                                            height: '40px', // กำหนดความสูงให้เท่ากับตัวเลือกอื่น
                                                            lineHeight: '40px', // ปรับการจัดแนวให้ตรงกลาง
                                                        }}
                                                    >
                                                        &nbsp; {/* ใช้เพื่อให้ div ไม่ว่างเปล่า */}
                                                    </div>
                                                    {filteredCategories.map(category => (
                                                        <div
                                                            key={category.id}
                                                            onClick={() => handleCategoryClick(category)}
                                                            style={styles.textDropdown}
                                                        >
                                                            {category.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {/* Section for Subject and years */}
                                <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                <div style={{ display: 'flex', gap: '20px', width: '100%' }}>
                                    {/* subject */}
                                    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '50%' }}>
                                        <label htmlFor="subject" style={{ marginBottom: '5px', fontSize: '18px', textAlign: 'left' }}>รายวิชา</label>
                                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="text"
                                                id="subject"
                                                name="subject"
                                                value={selectedSubject ? getNameSubjectMetadata(selectedSubject) : ''} 
                                                readOnly
                                                style={styles.inputShowtext}
                                            />
                                            <FontAwesomeIcon
                                                icon={faChevronDown}
                                                style={styles.iconDropdown}
                                                onClick={() => toggleDropdown('SubjectDropdown')}
                                            />
                                        </div>
                                        {showSubjectDropdown && (
                                            <div
                                                id="SubjectDropdown"
                                                style={styles.dropdowncontent}
                                            >
                                                 <div
                                                        onClick={() => handleSubjectClick(null)}
                                                        style={{
                                                            padding: '5px',
                                                            cursor: 'pointer',
                                                            borderBottom: '1px solid #ddd',
                                                            height: '40px', // กำหนดความสูงให้เท่ากับตัวเลือกอื่น
                                                            lineHeight: '40px', // ปรับการจัดแนวให้ตรงกลาง
                                                        }}
                                                    >
                                                        &nbsp; {/* ใช้เพื่อให้ div ไม่ว่างเปล่า */}
                                                    </div>
                                                {filteredSubjects.map(subject => (
                                                    <div
                                                        key={subject.id}
                                                        onClick={() => handleSubjectClick(subject)}
                                                        style={styles.textDropdown}
                                                    >
                                                        {subject.name}
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* ปีการศึกษา */}
                                    <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', width: '50%' }}>
                                        <label htmlFor="gen" style={{ marginBottom: '5px', fontSize: '18px',textAlign:'left' }}>รุ่น</label>
                                        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                        <input
                                            type="text"
                                            id="gen"
                                            name="gen"
                                            value={selectedGen ? getNameGenerationMetadata(selectedGen) : ''} 
                                            readOnly
                                            style={styles.inputShowtext}
                                        />
                                        <FontAwesomeIcon
                                            icon={faChevronDown}
                                            style={styles.iconDropdown}
                                            onClick={() => toggleDropdown('GenDropdown')}
                                        />
                                        </div>
                                        {showGenDropdown && (
                                        <div
                                            id="GenDropdown"
                                            style={styles.dropdowncontent}
                                        >
                                            <div
                                            onClick={() => handleGenClick(null)}
                                            style={{
                                                padding: '5px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #ddd'
                                            }}
                                            >
                                            <p></p>
                                            </div>
                                            {GenDropdownData.map(generation => (
                                            <div
                                                key={generation}
                                                onClick={() => handleGenClick(generation)}
                                                style={styles.textDropdown}
                                            >
                                                {generation.name}
                                            </div>
                                            ))}
                                        </div>
                                        )}
                                    </div>
                                    </div>
                                </div>
                                <button
                                    type="submit"
                                    style={styles.btnSearch}
                                >
                                    {loading ? (
                                        <span>กำลังค้นหา...</span>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: '8px', color: '#F9FAFB' }} />
                                            ค้นหา
                                        </>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    onClick={handleShowAll}
                                    style={styles.btnAllsearch}
                                >
                                    {loading ? (
                                        <span>กำลังค้นหา...</span>
                                    ) : (
                                        <>
                                            แสดงทั้งหมด
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <div style={{
                    display: 'flex',
                    gap: '42px',
                    justifyContent: 'center',
                }}>
                    {/* Calendar */}
                    <div style={{ width: '80%', margin: 'auto', padding: '20px', boxSizing: 'border-box' }}>
                        <Calendar
                            onChange={onChange}
                            value={date}
                            tileContent={tileContent}
                            onClickDay={handleDayClick}
                            onActiveStartDateChange={handleMonthChange}
                            locale="th-TH"
                            formatShortWeekday={(locale, date) => {
                                const weekdays = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'];
                                return weekdays[date.getDay()];
                            }}
                        />
                    </div>
                </div>
                <div style={{padding:'20px'}}>
                {filterCourseData?.map(item => (
                <div key={item.uid} style={styles.container}>
                    <div style={{ display: 'flex',gap:'20px'}}>
                        <div style={styles.left}>
                           <div style={{display:'flex',gap:'24px',color: '#44526E'}}>
                            <p>รุ่นที่ {getNameGenerationMetadata(item.generation)}</p>
                            <p>ปีการศึกษา {getNameYearMetadata(item.year)}</p>
                           </div>
                           <p style={{
                            color: '#44526E',
                            fontSize:'1.5vw',
                            fontWeight:'bold',
                            margin:'0'
                           }}>{getNameSubjectMetadata(item.subject)}</p>
                           <p style={{color: '#44526E'}}>หลักสูตร : {getNameCourseNameMetadata(item.name)}</p>
                           <p style={{color: '#44526E'}}>หมวดวิชา : {getNameCagegoryMetadata(item.category)}</p>
                           <div style={styles.teacherDateTime}>
                                <div style={styles.Detaildatteachtime}>
                                    <FontAwesomeIcon icon={faUser} style={{ color: '#44526e' , fontSize:'1.5vw'}} />
                                    <p style={{ margin: '0 auto' }}>{item.teacher}</p>
                                </div>
                                <div style={styles.Detaildatteachtime}>
                                    <FontAwesomeIcon icon={faCalendar} style={{ color: '#44526e' , fontSize:'1.5vw'}} />
                                    <p style={{ margin: '0 auto' }}>{convertToThaiDate(item.date)}</p>
                                </div>
                                <div style={styles.Detaildatteachtime}>
                                    <FontAwesomeIcon icon={faClock} style={{ color: '#44526e' , fontSize:'1.5vw'}} />
                                    <p style={{ margin: '0 auto' }}>{convertTimeFormat(item.time)}</p>
                                </div>
                    </div>
                        </div>
                        <div style={styles.right}>
                            <div>
                                <p style={styles.rowData}><strong>ขอบเขตการเรียนการสอน</strong></p>
                            </div>
                            <div>
                                <label  style={styles.rowData}>{item.description}</label>
                            </div>
                            <div>
                            <p  style={styles.rowData}> <strong>วัตถุประสงค์รายวิชา</strong></p>
                            </div>
                            <div>
                                <label  style={styles.rowData}>{item.objective}</label>
                            </div>
                        </div>
                    </div>  
                    <div style={{marginTop:'24px'}}>
                        <button type="button" onClick={() => { onSelectCourse(item.uid) }} 
                            style={{
                                width:'100%',
                                background:'#44526E',
                                color:'white',
                                borderRadius:'64px',
                                padding:'10px',
                                fontSize:'24px',
                                border:'none',
                                cursor:'pointer'
                            }}>ดูข้อมูลเพิ่มเติม
                        </button>
                    </div>
                </div>
            ))}
            </div>
            </div>
            {/* page */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
                alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
            }}>
                <div style={styles.pagination}>
                    <span
                    style={{
                        ...styles.paginationItem,
                        ...{ 
                            cursor: currentPage === 1 ? 'not-allowed' : 'pointer', 
                            color: currentPage === 1 ? '#ccc' : 'white',
                            fontSize: '30px', 
                            textDecoration: 'none',                            
                        },
                    }}
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    >
                    &lt;
                    </span>
                    {getPaginationItems().map(page => (
                    <span
                        key={page}
                        style={{
                        ...styles.paginationItem,
                        // ...{ fontWeight: currentPage === page ? 'bold' : 'normal' },
                        ...(currentPage === page ? styles.activePaginationItem : {}),
                        }}
                        onClick={() => onPageChange(page)}
                    >
                        {page}
                    </span>
                    ))}
                    <span
                    style={{
                        ...styles.paginationItem,
                        ...{ 
                            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', 
                            color: currentPage === totalPages ? '#ccc' : 'white',
                            fontSize: '30px', 
                            textDecoration: 'none',                            
                        },
                    }}
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    >
                    &gt;
                    </span>
                </div>
            </div>
        </div>
    );
    
};
const styles = {
    background: {
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: '0',
        left: '0',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: '-1',
    },  
    container:{
        boxSizing: 'border-box',
        background: '#FFFFFFB2',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '80%',
        borderRadius: '36px',
        margin: '20px auto',
        padding: '48px',
        display: 'block',
        textAlign:'left', 
        border:'1px solid #DDDDDD'           
    },
    majorRoomYear:{
        display:'flex',
        gap:'16px',
        fontSize:'16px',
    },
    teacherDateTime:{
        display:'flex',
        gap:'24px',
        width:'100%',
        marginTop:'20px'
    },
    infoTimeline: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'flex-start', // เปลี่ยนจาก 'center' เป็น 'flex-start'
        margin: '10px 0',
        background: '#6B7280',
        padding: '8px 24px',
        borderRadius: '18px',
    },
    left:{
        width:'100%',
        boxSizing:'border-box'
    },
    right:{
        width:'100%',
        background:'#f2f2f2',
        borderRadius:'36px',
        padding: '16px',
        fontSize:'16px',
        boxSizing:'border-box',
        wordWrap:'break-word',
        border:'1px solid #dddddd'
    },
    rowData:{
        marginTop:'0',
        marginBottom:'4px'
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
        alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
        margin: '20px 0',  // เพิ่มระยะห่างจากตาราง
        background: 'linear-gradient(90deg, #7C93B7 0%, #374151 100%)',
        width: '80%',
        borderRadius: '64px',  // เพิ่มขอบมนเล็กน้อยให้กับ pagination
        boxSizing: 'border-box',  // ทำให้ขนาดกล่องรวม padding และ border
    },
    
    paginationItem: {
        margin: '0 20px',
        cursor: 'pointer',
        fontSize: '16px',
        color: 'white',
        textDecoration: 'none',
    },    
    activePaginationItem: {
        backgroundColor: '#44526E',
        color: 'white',
        width: '100%',
        maxWidth:'56px',
        height:'56px',
        borderRadius: '34px',  
        padding: '5px',
        fontSize: '24px',
        textAlign:'center',
        display: 'flex',
        justifyContent: 'center',  // จัดให้อยู่ตรงกลางในแนวนอน
        alignItems: 'center',  // จัดให้อยู่ตรงกลางในแนวตั้ง
    },
    searchcontent:{
        boxSizing: 'border-box',
        backgroundColor: 'white',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '80%',
        borderRadius: '36px',
        margin: '20px auto',
        padding: '48px',
        display: 'block',
        fontSize: '32px',
        border:'1px solid #dddddd'
    },
    inputShowtext:{
        flexGrow: 1,
        height: '52px',
        borderRadius: '50px',
        border: '1px solid #ddd',
        padding: '0 20px',
        width: '100%',
        fontSize: '24px',
        textAlign: 'center',
        background:'#f9fafb'
    },
    inputDateTime:{
        flexGrow: 1,
        height: '52px',
        borderRadius: '50px',
        border: '1px solid #ddd',
        padding: '0 15px',
        boxSizing: 'border-box',
        width: '100%', // แก้ไขเพื่อให้เต็มความกว้าง
        fontSize: '24px',
        textAlign: 'center',
        background:'#f9fafb'
    },
    iconDropdown:{
        position: 'absolute',
        right: '15px',
        top: '50%',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        color: '#50515b',
        fontSize:'1vw'
    },
    dropdowncontent:{
        position: 'absolute',
        top: '105%',
        left: '0',
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        zIndex: 10,
        width: '100%',
        boxSizing: 'border-box',
    },
    textDropdown:{
        padding: '5px',
        cursor: 'pointer',
        borderBottom: '1px solid #ddd',
        fontSize:'1.5vw'
    },
    btnSearch:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        backgroundColor: '#44526E',
        color: 'white',
        border: 'none',
        cursor: 'pointer',
        marginTop: '10px',
        width: '100%',
        fontSize: '1.5vw',
        borderRadius: '50px',
        height: '52px',
        lineHeight: '52px',
    },
    btnAllsearch:{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '10px',
        backgroundColor: '#F9FAFB',
        color: '#44526E',
        border: '2px solid #44526E',
        cursor: 'pointer',
        marginTop: '10px',
        width: '100%',
        fontSize: '1.5vw',
        borderRadius: '50px',
        height: '52px',
        lineHeight: '52px',
    },
    Detaildatteachtime:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#f2f2f2',
        width: '100%',
        height: 'auto',
        padding: '24px',
        borderRadius:'15px',
        color:'#44526e',
        fontSize:'16px',
        textAlign:'center',
        boxSizing:'border-box',
        border:'1px solid #dddddd',
        gap:'10px'
    }
};

export default MyCoursePage;